import React from "react";
import Image from "components/image";
import WishlistButton from "components/wishlist/button";
import ProductLabel from "components/product/label";
import clsx from "clsx/lite";


const ImageWithOverlay = ({ baseImage, overlayImage, fallbackImg, title }) => (
	<>
		{baseImage ? <Image className={clsx(overlayImage ? "img-transition" : "img-transition-scale")} image={baseImage} />
			: fallbackImg && <img src={fallbackImg} alt={title} className={"img-transition-scale"} loading="lazy"/>}
		{overlayImage && 
				<Image className="hidden md:flex !absolute top-0 right-0 bottom-0 left-0 opacity-0 img-transition-scale" 
					image={overlayImage} />}
	</>
);

const ProductImages = ({ product, openModal, handleWishlistClick, showViewDetails = false, showModal = false, thirdImgAsPrimary }) => {
	const { title, previewImageUrl: fallbackImg, label, variant, previewImages = [] } = product;

	const [mainImage, hoverImage, experimentImage] = previewImages || [];
	const onSale = variant?.compareAtPrice && variant?.compareAtPrice > variant?.price;


	return (
		<div className="w-full relative overflow-hidden">
			<div className="images-v1-t">
				<ImageWithOverlay baseImage={mainImage} overlayImage={hoverImage} fallbackImg={fallbackImg} title={title}/>
			</div>
			<div className="images-v2-t">
				{thirdImgAsPrimary && experimentImage ? 
					<ImageWithOverlay  baseImage={experimentImage} overlayImage={mainImage} fallbackImg={fallbackImg} title={title} />
					: <ImageWithOverlay baseImage={mainImage} overlayImage={hoverImage} fallbackImg={fallbackImg} title={title} />}
			</div>
			{showViewDetails && (
				<>
					<ProductLabel data={label || {}} onSale={onSale} />
					<div className={clsx(
						"opacity-100 md:opacity-0 md:group-hover/card:opacity-100",
						"transition-all duration-300 absolute top-0 right-0 p-4")}>
						<div className="flex flex-col gap-4">
							<WishlistButton
								className="p-2 sm:p-3.5 bg-black rounded-full flex md:size-fit" id={variant?.id}
								iconClassName="fill-white size-4"
								handleClick={handleWishlistClick} />
						</div>
					</div>
					{showModal ?
						<button
							onClick={openModal}
							onKeyDown={(e) => e.key === "Enter" && openModal(e)}
							className="hidden md:block absolute bottom-0 w-full">
							<div className={clsx(
								"bg-beige py-2.5 w-full text-center uppercase transform translate-y-full",
								"transition-all duration-300 group-hover/card:translate-y-0")}>
								Quick view
							</div>
						</button>
						:
						<div className="hidden md:block absolute bottom-0 w-full">
							<div className={clsx(
								"bg-beige py-2.5 w-full text-center uppercase transform translate-y-full ",
								"transition-all duration-300 group-hover/card:translate-y-0")}>
								View details
							</div>
						</div>
					}
				</>
			)}
		</div >
	);
};

export default ProductImages;